import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TestimonialsCarouselProperty from '../components/TestimonialsCarouselProperty';
import CallAction from '../components/CallAction';

const PropertyView = () => {
  const { id } = useParams();
  const [propertyData, setPropertyData] = useState(null);
  const navigate = useNavigate();
  const [availabilityData, setAvailabilityData] = useState(null);
  const [isAvailable, setIsAvailable] = useState(false);
  const [bookingMessage, setBookingMessage] = useState('');


  const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');

  const getUserToken = () => localStorage.getItem('token');

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleWriteReviewClick = () => {
    if (isLoggedIn) {
      navigate(`/AddPropertyTestimonials/${id}`);
    } else {
      navigate('/Login');
    }
  };

const handleCheckAvailability = (e) => {
  e.preventDefault();
  const formData = new FormData(e.target);
  const availabilityParams = {
    property_id: propertyData._id,
    start_date: formData.get('start_date'),
    end_date: formData.get('end_date'),
    no_of_guest: formData.get('no_of_guest')
  };

  const queryString = new URLSearchParams(availabilityParams).toString();

  fetch(`https://dayoffice24.it/api/check-availability?${queryString}`)
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        setAvailabilityData(data.data);
        setIsAvailable(true);
        setBookingMessage('Property is available for the selected dates.');
        
        // Get the button element and its text content
        const buttonElement = e.target.querySelector('button');
        const buttonText = buttonElement.textContent;
        
        if (buttonText === 'Book Now') {
          // Redirect to Checkout page with necessary query parameters
          navigate(`/Checkout?start_date=${formData.get('start_date')}&end_date=${formData.get('end_date')}&property_id=${propertyData._id}`);
        }
      } else {
        setIsAvailable(false);
        setBookingMessage('Property is not available for the selected dates.');
      }
    })
    .catch((error) => {
      console.error('Error fetching availability data:', error);
    });
};




  useEffect(() => {
    const token = getUserToken();
    setIsLoggedIn(!!token);
  }, []);

  useEffect(() => {
    fetch(`https://dayoffice24.it/api/property/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setPropertyData(data.data);
        } else {
          throw new Error('API returned an error:' + data.message);
        }
      })
      .catch((error) => {
        console.error('Error fetching property data:', error);
      });
  }, [id]);

  if (!propertyData) {
    return <p>Loading...</p>;
  }




  return (
    <div className="main_wrap">
      <Header />

      <div className="content-wrapper">
        <section className="property-details-wrap pt-100">
          <div className="container">
            <div className="row">
              <div className="col-xl-8">
                <div className="property-details">
                  <div className="row align-items-start">
                    <div className="col-md-8">
                      <div className="property-title">
                        <h2>{propertyData.property_name}</h2>
                        <ul className="property-metainfo list-style">
                          <li>
                            <i className="flaticon-location"></i>
                            {propertyData.address}
                          </li>
                          <li>
                            <i className="flaticon-square"></i>
                            {propertyData.property_size} Sqft
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <p className="property-price">
                        €{propertyData.price} <span>/ Day</span>
                      </p>
                    </div>
                  </div>
                  <div className="property-img">
                    <div className="gallery">
                      {propertyData.property_image.map((image) => (
                        <div key={image._id} className="item">                         
                            <img
                              src={image.property_image}
                              alt="Property Image"
                            />
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="property-desc">
                    <h4>Description</h4>
                    <p>{propertyData.desc}</p>
                  </div>


                </div>
              </div>

              <div className="col-xl-4">
                <div className="sidebar">
                    <div className="search_sidebar sidebar-widget">
                    <h4>Check Availability</h4> 

                    <p className="head_section"><strong>Current Availabe Dates</strong></p>
                    <p className="dates_before">09-Aug - 12-Aug</p>

                    <form onSubmit={handleCheckAvailability} className="property-search-form">
                      <div className="form-group">
                          <input
                            type="date"
                            name="start_date"
                            required
                            className="custom-date-input"
                            placeholder="Check In"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                          />
                      </div>
                      <div className="form-group">
                         <input
                            type="date"
                            name="end_date"
                            required
                            className="custom-date-input"
                            placeholder="Check Out"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                      </div>
                      <div className="form-group"> 
                        <select name="no_of_guest" id="price-range">
                          <option value="0" data-display="Price Range">Select Guest</option>
                          <option value="1">1 Guest</option>
                          <option value="2">2 Guest</option>
                          <option value="3">3 Guest</option>
                          <option value="4">4 Guest</option>
                          <option value="5">5 Guest</option>
                          <option value="6">6 Guest</option>
                          <option value="7">7 Guest</option>
                        </select>
                      </div>
                       <p className="heightlihg_text">{bookingMessage}</p>
                       <div className="form-group">
                        {isAvailable ? (
                          <button type="submit" className="btn style2">
                            Book Now
                          </button>
                        ) : (
                          <button type="submit" className="btn style2">
                            Check Availability
                          </button>
                        )}
                      </div>
                      <input type="hidden" name="property_id" value={propertyData._id} />

                    </form> 

                  </div>


                  <div className="search_sidebar sidebar-widget">
                     <h4>Listing Owner Details</h4>
                     <div className="agent-info-box">
                          <div className="agent-name-wrap">
                            <div className="agent-img">
                              <img src={propertyData.user.avatar} alt="Agent Image" />
                            </div>
                            <div className="agent-name">
                              <h6>{propertyData.user.name}</h6>
                            </div>
                          </div>
                          <ul className="agent-address list-style">
                            <li><i className="ri-map-pin-line"></i>{propertyData.user.address}</li>
                            <li><i className="ri-phone-line"></i>{propertyData.user.mobile_no}</li>
                            <li><i className="ri-mail-send-line"></i><a href={`mailto:${propertyData.user.email}`}>{propertyData.user.email}</a></li>
                          </ul>
                        </div>
                  </div>

                  <div className="property-desc property_heightligh_box">
                    <h4>Availabe Paid Services</h4>
                    <ul className="property-annuties list-style">
                      {propertyData.property_service.map((service) => (
                        <li key={service._id}>
                          <i className="ri-checkbox-multiple-line"></i>
                          {service.service.service_name}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="single_property_reviews ptb-50">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <h4>Reviews</h4>
                <div className="testimonial-slider-two owl-carousel">
                  <TestimonialsCarouselProperty propertyId={id} /> 
                </div>

                <div className="center_btn">
                  <button className="btn style1" onClick={handleWriteReviewClick}>
                    Write a Review
                  </button>
                </div>

              </div>
            </div>
          </div>
        </section>

      </div>

      <CallAction />

      <Footer />
    </div>
  );
};

export default PropertyView;
